import { render, staticRenderFns } from "./CreateServiceProvider.vue?vue&type=template&id=d195f0f6&scoped=true"
import script from "./CreateServiceProvider.vue?vue&type=script&lang=js"
export * from "./CreateServiceProvider.vue?vue&type=script&lang=js"
import style0 from "./CreateServiceProvider.vue?vue&type=style&index=0&id=d195f0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d195f0f6",
  null
  
)

export default component.exports